<template>
    <div>
        <v-container class="justify-center">
            <v-row>
                <v-col cols="12">
                    <v-card class="pl-6" >
                        <v-card-title class="font-weight-bold pl-4">
                            <h3>使用时长算法</h3>
                            <v-spacer></v-spacer>
                            <v-btn  color="primary"  @click="change()" :disabled="disable">修改</v-btn>
                        </v-card-title>
                        <v-row class="pl-7">
                            一小时内计算方法
                        </v-row>
                        <v-row>
                            <v-col class="pl-7">
                                <!--              greater-than  greater-than-or-equal less-than less-than-or-equal-->
                                <v-text-field   type="number" style="width: 90px"
                                                class="float-left "
                                                dense
                                                solo-inverted
                                                readonly
                                                suffix="分钟" value="0" />
                                <div class="pt-2 pl-4 pr-4 float-left" >
                                    <v-icon>mdi-less-than
                                    </v-icon>
                                    时长
                                    <v-icon>mdi-less-than-or-equal
                                    </v-icon>
                                </div>
                                <v-text-field  type="number" class="float-left"
                                               style="width: 90px"
                                               dense solo suffix="分钟"
                                               readonly
                                               solo-inverted
                                               value="0"
                                               v-model="computeConfigInfoQuery.paramMinuteInner" />
                                <div class="pt-2 pl-4 pr-4 float-left">
                                    使用时间算为
                                </div>
                                <v-select style="width: 90px;float: left"
                                          dense solo
                                          readonly
                                          solo-inverted
                                          :items="itemsAnother"
                                          v-model="computeConfigInfoQuery.paramHourInner"></v-select>
                                <div class="pt-2 pl-4 pr-4 float-left">
                                    小时
                                </div>

                                <!--              greater-than  greater-than-or-equal less-than less-than-or-equal-->
                                <v-text-field   type="number" class="float-left"
                                                style="width: 90px"
                                                dense
                                                readonly
                                                solo-inverted
                                                value="0"
                                                solo suffix="分钟" v-model="computeConfigInfoQuery.paramMinuteInner"/>
                                <div class="pt-2 pl-4 pr-4 float-left" >
                                    <v-icon>mdi-less-than
                                    </v-icon>
                                    时长
                                    <v-icon>mdi-less-than-or-equal
                                    </v-icon>
                                </div>
                                <v-text-field  type="number"
                                               style="width: 90px"
                                               class="float-left"
                                               readonly solo-inverted
                                               dense solo suffix="分钟"
                                               value="60"/>
                                <div class="pt-2 pl-4 pr-4 float-left" >
                                    使用时间算为1小时
                                </div>
                            </v-col>
                        </v-row>

                        <v-row class="pl-7">
                            一小时以上累加计算方法
                        </v-row>
                        <v-row>
                            <v-col class="pl-7" >
                                <!--              greater-than  greater-than-or-equal less-than less-than-or-equal-->
                                <v-text-field   type="number"
                                                class="float-left"
                                                style="width: 90px"
                                                dense
                                                solo
                                                suffix="分钟"
                                                readonly
                                                solo-inverted
                                                value="0"/>
                                <div class="pt-2 pl-4 pr-4 float-left" >
                                    <v-icon>mdi-less-than
                                    </v-icon>
                                    时长
                                    <v-icon>mdi-less-than-or-equal
                                    </v-icon>
                                </div>
                                <v-text-field  type="number"
                                               style="width: 90px"
                                               class="float-left"
                                               dense
                                               solo
                                               suffix="分钟"
                                               readonly
                                               solo-inverted
                                               v-model="computeConfigInfoQuery.paramMinuteOuter"/>
                                <div class="pt-2 pl-4 pr-4 float-left" >
                                    使用时间算为
                                </div>
                                <v-select style="width: 90px" class="float-left"
                                          dense solo
                                          readonly
                                          :items="itemsAnother"
                                          readonly
                                          solo-inverted
                                          v-model="computeConfigInfoQuery.paramHourOuter"></v-select>
                                <div class="pt-2 pl-4 pr-4 float-left" >
                                    小时
                                </div>

                                <!--              greater-than  greater-than-or-equal less-than less-than-or-equal-->
                                <v-text-field   type="number" style="width: 90px"
                                                class="float-left"
                                                readonly
                                                solo-inverted
                                                dense
                                                solo
                                                suffix="分钟"
                                                v-model="computeConfigInfoQuery.paramMinuteOuter"/>
                                <div class="pt-2 pl-4 pr-4 float-left">
                                    <v-icon>mdi-less-than
                                    </v-icon>
                                    时长
                                    <v-icon>mdi-less-than-or-equal
                                    </v-icon>
                                </div>
                                <v-text-field  type="number"
                                               style="width: 90px"
                                               class="float-left"
                                               dense
                                               solo
                                               suffix="分钟"
                                               readonly solo-inverted
                                               value="60"/>
                                <div class="pt-2 pl-4 pr-4 float-left">
                                    使用时间算为1小时
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

<!--        弹窗-->
        <v-dialog  v-model="dialog" width="1080px" >
            <v-form ref="form">
                <v-card width="1080px">
                    <v-row style="width: 1080px" class="pl-7">
                        一小时内计算方法
                    </v-row>
                    <v-row style="width: 1080px">
                        <v-col class="pl-7">
                            <!--              greater-than  greater-than-or-equal less-than less-than-or-equal-->
                            <v-text-field   type="number" style="width: 95px"
                                            class="float-left "
                                            dense
                                            solo
                                            solo-inverted
                                            readonly
                                            suffix="分钟" value="0" />
                            <div class="pt-2 pl-4 pr-4 float-left" >
                                <v-icon>mdi-less-than
                                </v-icon>
                                时长
                                <v-icon>mdi-less-than-or-equal
                                </v-icon>
                            </div>
                            <v-text-field  type="number" class="float-left"
                                           style="width: 95px"
                                           dense solo suffix="分钟"
                                           :readonly="changeFlag"
                                           :solo-inverted="changeFlag"
                                           :rules="[()=>computeConfigInfoUpdate.paramMinuteInner>=0&&computeConfigInfoUpdate.paramMinuteInner<=60
                                           ||'值在0~60之间']"
                                           v-model="computeConfigInfoUpdate.paramMinuteInner"
                                           ref="computeConfigInfoUpdate.paramMinuteInner" />
                            <div class="pt-2 pl-4 pr-4 float-left">
                                使用时间算为
                            </div>
                            <v-select style="width: 95px;float: left"
                                      dense solo
                                      :readonly="changeFlag"
                                      :solo-inverted="changeFlag"
                                      :items="items"
                                      v-model="computeConfigInfoUpdate.paramHourInner"></v-select>
                            <div class="pt-2 pl-4 pr-4 float-left">
                                小时
                            </div>

                            <!--              greater-than  greater-than-or-equal less-than less-than-or-equal-->
                            <v-text-field   type="number" class="float-left"
                                            style="width: 95px"
                                            dense
                                            readonly
                                            solo-inverted
                                            solo suffix="分钟" v-model="computeConfigInfoUpdate.paramMinuteInner"/>
                            <div class="pt-2 pl-4 pr-4 float-left" >
                                <v-icon>mdi-less-than
                                </v-icon>
                                时长
                                <v-icon>mdi-less-than-or-equal
                                </v-icon>
                            </div>
                            <v-text-field  type="number"
                                           style="width: 95px"
                                           class="float-left"
                                           readonly solo-inverted
                                           dense solo suffix="分钟"
                                           value="60"/>
                            <div class="pt-2 pl-4 pr-4 float-left" >
                                使用时间算为1小时
                            </div>

                        </v-col>
                    </v-row>

                    <v-row class="pl-7" style="width: 1080px">
                        一小时以上累加计算方法
                    </v-row>
                    <v-row style="width: 1080px">
                        <v-col class="pl-7" >
                            <!--              greater-than  greater-than-or-equal less-than less-than-or-equal-->
                            <v-text-field   type="number"
                                            class="float-left"
                                            style="width: 95px"
                                            dense
                                            solo
                                            suffix="分钟"
                                            readonly
                                            solo-inverted
                                            value="0"/>
                            <div class="pt-2 pl-4 pr-4 float-left" >
                                <v-icon>mdi-less-than
                                </v-icon>
                                时长
                                <v-icon>mdi-less-than-or-equal
                                </v-icon>
                            </div>
                            <v-text-field  type="number"
                                           style="width: 95px"
                                           class="float-left"
                                           dense
                                           solo
                                           suffix="分钟"
                                           :readonly="changeFlag"
                                           :solo-inverted="changeFlag"
                                           :rules="[()=>computeConfigInfoUpdate.paramMinuteOuter>=0&&computeConfigInfoUpdate.paramMinuteOuter<=60
                                           ||'值在0~60之间']"
                                           ref="computeConfigInfoUpdate.paramMinuteOuter"
                                           v-model="computeConfigInfoUpdate.paramMinuteOuter"/>
                            <div class="pt-2 pl-4 pr-4 float-left" >
                                使用时间算为
                            </div>
                            <v-select style="width: 95px" class="float-left"
                                      dense solo
                                      readonly
                                      :items="items"
                                      :readonly="changeFlag"
                                      :solo-inverted="changeFlag"
                                      v-model="computeConfigInfoUpdate.paramHourOuter"></v-select>
                            <div class="pt-2 pl-4 pr-4 float-left" >
                                小时
                            </div>

                            <!--              greater-than  greater-than-or-equal less-than less-than-or-equal-->
                            <v-text-field   type="number" style="width: 95px"
                                            class="float-left"
                                            readonly
                                            solo-inverted
                                            dense
                                            solo
                                            suffix="分钟"
                                            v-model="computeConfigInfoUpdate.paramMinuteOuter"/>
                            <div class="pt-2 pl-4 pr-4 float-left">
                                <v-icon>mdi-less-than
                                </v-icon>
                                时长
                                <v-icon>mdi-less-than-or-equal
                                </v-icon>
                            </div>
                            <v-text-field  type="number"
                                           style="width: 95px"
                                           class="float-left"
                                           dense
                                           solo
                                           suffix="分钟"
                                           readonly solo-inverted
                                           value="60"/>
                            <div class="pt-2 pl-4 pr-4 float-left">
                                使用时间算为1小时
                            </div>
                        </v-col>
                    </v-row>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialog=!dialog" >关闭</v-btn>
                        <v-btn color="primary" @click="update()">提交</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <!--loading组件 start-->
        <z-loading v-model="isShowLoading"></z-loading>
        <!--loading组件 end-->

        <z-notify ref="notify" ></z-notify>

    </div>
</template>

<script>
    import {
        update,
        computeConfigQuery
    } from '@/api/computeConfig'
    import {getAcctInfo} from "../../api/login";

    export default {
        name: "ComputeConfig",
        data(){
            return {
                msg:'',
                isShowLoading: false,
                computeConfigInfoUpdate:{
                    id:'',
                    paramHourInner:0,
                    paramHourOuter:0,
                    paramMinuteInner:30,
                    paramMinuteOuter:30
                },
                computeConfigInfoQuery:{
                    id:'',
                    paramHourInner:0,
                    paramHourOuter:0,
                    paramMinuteInner:30,
                    paramMinuteOuter:30,
                },
                items:[0,0.5],
                itemsAnother:[0,0.5],
                changeFlag:false,
                dialog: false,
                disable:false
            }
        },
        mounted() {
            this.queryComputeConfig();
        },
        methods:{
            returnFalse(e){
                e.preventDefault();
            },

            update(){
                if ( this.$refs.form.validate()){

                    var reqData = this.computeConfigInfoUpdate;
                    console.log(reqData,"121212");
                    update(reqData).then(res => {
                        this.$refs.notify.show("修改成功", {timeout: 900, color: 'green'});
                        this.dialog = false;
                        console.log(res)
                        this.queryComputeConfig();
                    }).catch(err => {
                        this.isShowLoading = false;
                    });
                }else {
                    this.dialog = true;
                }
            },

            //查询时长配置
            queryComputeConfig(){
                this.isShowLoading = true;
                computeConfigQuery({}).then(res => {
                    this.isShowLoading = false;
                    this.computeConfigInfoUpdate = res;
                    Object.assign(this.computeConfigInfoQuery,this.computeConfigInfoUpdate)
                    console.log(this.computeConfigInfoQuery,"12121212121212")
                    if (this.computeConfigInfoQuery.id ==null){
                        this.computeConfigInfoQuery.paramMinuteOuter=30;
                        this.computeConfigInfoQuery.paramMinuteInner=30;
                        this.computeConfigInfoQuery.paramHourOuter=0;
                        this.computeConfigInfoQuery.paramHourInner=0;
                    }
                }).catch(err => {
                    this.isShowLoading = false;
                });
                console.log("----------")
                getAcctInfo().then(res=>{
                    console.log(res+"=========")
                    if (res.isAdmin =='admin'){
                        console.log('admin')
                        this.disable=false;
                    }else {
                        console.log('normal');
                        this.disable=true;
                    }
                })
            },
            //改变状态
            change(){
                this.dialog = !this.dialog;
                if (this.dialog){
                    Object.assign(this.computeConfigInfoUpdate,this.computeConfigInfoQuery);
                    console.log(this.computeConfigInfoUpdate)
                }
            }
        }
    }

</script>


<style scoped>

</style>
